import {createAction} from 'redux-actions';
import {ARTICLES_SET_ACTIVE_FILTERS} from '../../action-types';

export default createAction(ARTICLES_SET_ACTIVE_FILTERS, (activeFilters, data) => v12.filter.set(activeFilters, data), () => ({key: 'lowest_price_sales'}));
